<div class="w-full flex flex-column justify-content-center align-items-center gap-3">
  <div class="company-logo row full-width align-center">
    <img alt="Company logo" src="{{ logoSource }}" />
    <button *ngIf="canEditCompany" (click)="uploadLogo()" mat-icon-button matTooltip="Change logo" class="align-end">
      <mat-icon svgIcon="settings_edit_on"></mat-icon>
    </button>
  </div>

  <div class="flex flex-column-reverse align-items-center">
    <h1 class="company-view__title">Company Page</h1>
    <mat-icon class="construction-hat-icon" svgIcon="personscreen_empty"></mat-icon>
  </div>

  <div class="flex flex-column justify-content-center align-items-center">
    <button primary-button [isRounded]="true" *ngIf="canInvitePeople" id="intercom-tour-add-employee" (click)="addEmployee()">
      <!-- svg omitted for brevity -->
      <span>Add employee</span>
    </button>
  </div>

  <mat-accordion displayMode="default" multi="true">
    <mat-expansion-panel id="intercom-tour-company-details">
      <mat-expansion-panel-header>
        <mat-panel-title>Company details</mat-panel-title>
        <mat-panel-description>Information about your company</mat-panel-description>
      </mat-expansion-panel-header>

      <div class="company-info-box row space-around align-center responsive-column">
        <span *ngIf="company?.orgNumber">Org number: {{ company?.orgNumber }}</span>
        <span *ngIf="company?.address as address">Address: {{ address?.street + ", " + address?.city }}</span>
      </div>

      <div class="row">
        <app-settings-group
          class="full-width"
          [readonly]="!canEditCompany"
          title=""
          (onEditable)="onEditable($event)"
          (onSave)="saveCompanyInfo()"
        >
          <form [formGroup]="companyInfoForm" class="column space-between">
            <h4>Name</h4>
            <mat-form-field>
              <input formControlName="name" matInput placeholder="Company name" />
            </mat-form-field>

            <h4>Reports PDF settings</h4>
            <mat-form-field>
              <textarea matInput #footer maxlength="80" formControlName="pdfFooter" type="text" placeholder="Pdf footer text"></textarea>
              <mat-hint align="start"
                ><strong class="label">This will be displayed on all pdf exports in the footer section</strong></mat-hint
              >
              <mat-hint align="end">{{ footer.value.length }} / 80</mat-hint>
            </mat-form-field>
          </form>
        </app-settings-group>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel id="intercom-tour-employees">
      <mat-expansion-panel-header>
        <mat-panel-title>Employees</mat-panel-title>
        <mat-panel-description>Add your colleagues as users</mat-panel-description>
      </mat-expansion-panel-header>

      <people-list-item *ngFor="let person of people$ | async; trackBy: trackByUid" [person]="person">
        <ng-container *ngIf="currentUserCompanyRole && company && roles">
          <people-role-selector
            [roles]="roles"
            [person]="person"
            [peopleListOf]="company"
            [showRoleSelector]="canChangePeopleRole"
            [currentUserRole]="currentUserCompanyRole"
            [editorCount]="2"
            [ownerCount]="2"
          >
          </people-role-selector>

          <button *ngIf="currentUserCompanyRole.roleType === roleType.COMPANY_ADMINISTRATOR" mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu">
            <button mat-menu-item [disabled]="userRemovalInProgress" (click)="removeCompanyMemberClicked(person)">
              Remove member from company
            </button>
          </mat-menu>
        </ng-container>
      </people-list-item>

      <checkd-pending-invitations-list
        *ngIf="pendingCompanyInvites$ | async as invitations"
        [canRemoveInvitations]="currentUserCompanyRole.roleType === roleType.COMPANY_ADMINISTRATOR"
        [invitations]="invitations"
      ></checkd-pending-invitations-list>

      <mat-action-row>
        <button primary-button [isRounded]="true" *ngIf="canInvitePeople" (click)="addEmployee()">
          <!-- svg omitted -->
          <span>Add employee</span>
        </button>
      </mat-action-row>
    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header id="intercom-tour-item-tag-manager">
        <mat-panel-title>Item tag manager</mat-panel-title>
        <mat-panel-description>Create and manage company item tags</mat-panel-description>
      </mat-expansion-panel-header>
      <checkd-tags placeholder="Add more item tags" [tags]="tags" [areTagsEditable]="canEditCompany" (onTagsUpdated)="updateTags($event)">
      </checkd-tags>
    </mat-expansion-panel>

    <!--    UNCOMMENT THIS WHEN WE ENABLE 2FA-->
    <mat-expansion-panel *ngIf="canEditCompany && companyHasSsoAdLoginFeature">
      <mat-expansion-panel-header id="invite-people-using-ad">
        <mat-panel-title>Invitation settings</mat-panel-title>
        <mat-panel-description>Settings of how invitations behave</mat-panel-description>
      </mat-expansion-panel-header>
      <p>
        <p-checkbox
          name="restrict-to-ad"
          [disabled]="checkLoginMethodPresent('microsoft')"
          [(ngModel)]="loginMethods"
          value="microsoft"
          (onChange)="updateLoginMethods()"
        ></p-checkbox>
        Enable AD login
      </p>
      <p>
        <p-checkbox
          name="restrict-to-ad"
          [disabled]="false"
          [(ngModel)]="loginMethods"
          value="usernameAndPassword"
          (onChange)="updateLoginMethods()"
        ></p-checkbox>
        Enable username and password
      </p>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<p-toast position="bottom-center" key="bc"></p-toast>
